import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/courses.action'
import setNotificationEmail from 'api/administration/courses/SetNotificationEmail'
import editCourse from 'api/administration/courses/Edit'
import { push } from 'connected-react-router'
import { ErrorToast } from '../../../components/ui/toast/toastsTemplates'
import I18n from '../../../i18n'

async function handleEditCourse(data: any, courseId: string) {
  return await editCourse(data, courseId)
}

async function handleSetNotificationEmail(data: any, courseId: string) {
  return await setNotificationEmail(data, courseId)
}

function* setNotificationEmailEffectSaga(action: any) {
  try {
    yield call(handleEditCourse, action.payload.course, action.payload.courseId)
    const { emailSubject, emailBody, courseId, emailType } = action.payload
    yield call(handleSetNotificationEmail, { emailSubject, emailBody, courseId, emailType }, action.payload.courseId)
    yield put(push(`/administration/courses/${action.payload.courseId}/edit`))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.editError'))
    console.log('error: ', error)
  }
}

export function* setNotificationEmailWatcherSaga() {
  yield takeLatest(fromActions.COURSES_SET_EMAIL_NOTIFICATION, setNotificationEmailEffectSaga)
}
